import { render, staticRenderFns } from "./comp-project-info.vue?vue&type=template&id=188d94dd&scoped=true&"
import script from "./comp-project-info.vue?vue&type=script&lang=js&"
export * from "./comp-project-info.vue?vue&type=script&lang=js&"
import style0 from "./comp-project-info.vue?vue&type=style&index=0&id=188d94dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188d94dd",
  null
  
)

export default component.exports